import { render, staticRenderFns } from "./CreateOrganization.vue?vue&type=template&id=9f9ad31e&"
import script from "./CreateOrganization.vue?vue&type=script&lang=js&"
export * from "./CreateOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports